import styled from "styled-components";
import CustomSearchField from "../../../Elements/CustomViews/CustomSearchField";
import { CustomListSearchInterface } from "../../../../Models/Common/List/ListInterfaces";
import CustomLegend from "../Legend/CustomLegend";
import { Grid, IconButton, Stack } from "@mui/material";
import { IconFilter } from "@tabler/icons-react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import QueryBuilderHelper from "../../../../Utilities/Helpers/QueryBuilderHelper";


const CustomListSearch = (props: CustomListSearchInterface) => {
  // const location = useLocation()
  // const searchValue = QueryBuilderHelper.DefaultSearchValue()

  const [showFilters, setShowFilters] = useState(false)
  return <Stack direction="column"
    spacing={2}
    sx={{
      margin: '20px'
    }}>
    <Stack direction="row"
      spacing={2}
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
      }}>
      <Stack direction="row"
        spacing={2}
        sx={{
          // justifyContent: "space-between",
          alignItems: "center",
        }}>
        <CustomSearchField searchValue={props.searchValue} onChangeSearch={props.onChangeSearch}
          placeholder={props.searchPlaceholder ?? "Search"} />
        {!props?.hideFilterBtn && <IconButton onClick={() => setShowFilters((prev) => !prev)}>
          <IconFilter size={20} />
        </IconButton>}
      </Stack>
      {props.legends && <CustomLegend legends={props.legends}
        onClickLegendItem={(id) => props?.onClickLegendItem ? props?.onClickLegendItem(id) : {}} />}
    </Stack>
    {showFilters && <Grid container spacing={1} columns={{ xs: 2, sm: 4, md: 4, lg: 6 }}>
      {props.children?.map((x, index) => {
        return <Grid key={index} >{x}</Grid>
      })}
    </Grid>}
  </Stack>
}

export default CustomListSearch;